import { useContext } from 'react';
import { AudioPlayerContext } from '../providers/AudioPlayerProvider';
import type { TAudioPlayerContextValue } from '../types/audioPlayer.types';

export function useAudioPlayer(): TAudioPlayerContextValue {
  const context = useContext(AudioPlayerContext);
  if (!context) {
    throw new Error('useAudioPlayer must be used within an AudioPlayerProvider');
  }
  return context;
}

export default useAudioPlayer;
